import { cn } from '../../../../lib/utils';
import { badgeVariants } from './utils';
import { BadgeProps } from './interface';

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
export type { BadgeProps };
